<template>
    <div id="app">
      <router-view />
    </div>
  </template>
  
  <script>
  import {getDicKey}from "@/api/system"
  export default {
    name: 'App',
    data () {
      return {
        dictionaryList: {}
      }
    },
    mounted () {
      // this.getDic()
    },
    methods: {
    
    }
  }
  </script>
  